import { Breadcrumbs } from 'components/bredcrambs';
import { useAuth } from 'context/auth';
import { Layout } from 'components/layout';
import { LoadMoreButton } from 'components/load-more-button';
import { LoginModal } from 'components/modal/login';
import { Title } from 'components/title';
import { useState } from 'react';
import styles from './styles.module.css';

import { Icon } from 'common/icon';
import { Button } from 'common/new-button';
import { TopicCommentSection as CommentSection } from 'components/template/topic-thread/comment-section';

import { questions as questionsBreadcrumbs } from 'constants/routes-breadcrumbs';
import { useLoginModal } from 'hooks';

import { FAQComponent } from 'components/casino-faq';
import { CustomMetadata } from 'components/metadata';
import { TopicModal } from 'components/modal/topic';
import { allMetadata } from 'constants/metadata';
import { IQuestion } from 'constants/types';
import { useQuestionsPagination } from 'hooks/useQuestionsPagination';
import { NavigationBar } from '../casino/casino-navigations';

interface Props {
  questions: IQuestion[];
}

export const QuestionsPage = ({ questions }: Props) => {
  const [isModalVisible, setModalVisible] = useState<boolean>(false);

  const {
    page,
    isLast,
    setPage,
    isFetching,
    data: questionsPagination = [],
  } = useQuestionsPagination({ collection: null });

  const { isLoggedIn } = useAuth();
  const {
    handleCloseLoginModal,
    handleConfirmLoginModal,
    handleVisibleLoginModal,
    isLoginVisible,
  } = useLoginModal();

  const data = questionsPagination?.length
    ? questionsPagination
    : (questions ?? []);

  const showMoreButton = !isLast ? (
    <LoadMoreButton
      isAuto={false}
      isVisible={true}
      onClick={() => {
        setPage(page + 1);
      }}
      variant={'transparent'}
      description="Load more"
      isFetching={isFetching}
      className={styles.loadmoreButton}
    />
  ) : undefined;

  return (
    <Layout hasFooter isSearchInputMobileVisible bgVariant="basic">
      <CustomMetadata metadata={allMetadata.allQuestions} />
      <main className={styles.main}>
        <div className={styles.container_s}>
          <div className={styles.breadcrumbs}>
            <Breadcrumbs items={[...questionsBreadcrumbs]} />
          </div>
          <Title
            text="Topics"
            description={`Sign up, create a topic, and get support from community members or our experienced admins\nWe created this space for you to get help, advice, or just to vent. Choose a category and tell your story.`}
            button={
              <div className={styles.wrapper_btn}>
                <Button
                  icon={<Icon.MessageThird width="16" height="16" />}
                  className={styles.button}
                  text={'Ask a question'}
                  onClick={() =>
                    isLoggedIn
                      ? setModalVisible(true)
                      : handleVisibleLoginModal()
                  }
                />
              </div>
            }
            variant="twocolumns"
            navigationBar={
              <div className={styles.navigation}>
                <NavigationBar
                  arrow
                  // items={navItems}
                  items={[]}
                  variantPadding="small"
                />
              </div>
            }
            gap={20}
          />
          <TopicModal isVisible={isModalVisible} setVisible={setModalVisible} />
          {data.length > 0 ? (
            <CommentSection
              variant="question"
              items={data}
              showMoreButton={showMoreButton}
            />
          ) : (
            !isFetching && (
              <div className={styles.emptyMessage}>
                No questions found. Be the first to submit a question!
              </div>
            )
          )}

          <FAQComponent
            customFaq={[
              {
                title: 'How do I ask a question?',
                description:
                  'Simply register on the site, then use the question submission feature to post your inquiry. Once submitted, our community and experts will respond to your question.',
              },
              {
                title: 'How long does it take to get an answer?',
                description:
                  'Answers are typically provided within 24-48 hours, depending on the complexity of the question and availability of experts.',
              },
              {
                title: 'Can I ask about any gambling topic?',
                description:
                  'Yes, feel free to ask about any aspect of gambling, including game rules, online casino reviews, strategies, or payment methods.',
              },
              {
                title:
                  'Do I need to be a professional gambler to ask a question?',
                description:
                  'No, our service is for everyone, whether you’re a beginner or a seasoned player. We encourage questions from all experience levels.',
              },
              {
                title: 'Are the answers trustworthy?',
                description:
                  'Yes, we have a team of experienced players and industry experts who provide accurate and reliable answers to your questions.',
              },
              {
                title: "Can I answer other people's questions?",
                description:
                  'Absolutely! Once registered, you can contribute by answering questions from other users. Share your knowledge and help grow the community!',
              },
            ]}
          />
        </div>
        <LoginModal
          isVisible={isLoginVisible}
          onClose={handleCloseLoginModal}
          confirmOnClick={handleConfirmLoginModal}
        />
      </main>
    </Layout>
  );
};
